import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Button, Modal } from 'antd'
import { AppTypeContext, UserFeedbackComContext } from '../..'
import { shopLogClstag } from '../../../shop/log'
import { erpLogClstag } from '../../../erp/log'
import { ExclamationCircleOutlined } from '@ant-design/icons'
export enum Status {
  '未完善' = 1,
  '审核成功',
  '审核失败',
  '审核中',
  '机审通过',
}

const { confirm } = Modal

export const resSetCode = [
  'smartPicTransparent',
  'smartPicWhite',
  'smartContentSell',
  'smartContentSell2',
  'smartContentSell3',
  'smartContentSortTitle',
]

export const statusMaps = {
  1: {
    color: '#C4C4C4',
  },
  2: {
    color: '#17C574',
  },
  3: {
    color: '#F2270C',
  },
  4: {
    color: '#2D64FF',
  },
  5: {
    color: '#2D64FF',
  },
}

const resetStatus = (record, updateData) => {
  record.editorStatus = false
  updateData({
    skuId: record.skuId,
    status: false,
  })
}

const resultCallback = (res, record, postData, updateData) => {
  record.editorStatus = false
  record.skuMaterialStatus = Status['审核中']
  if (res && res.length) {
    res.forEach((item) => {
      if (item.skuId === record.skuId) {
        resSetCode.forEach((code) => {
          if (record[code]) {
            record[code].value = postData[code]
          } else {
            record[code] = {
              value: postData[code],
            }
          }
          if (item[code] && item[code].failReason && record[code]) {
            record[code].failReason = item[code].failReason
            record[code].status = 5
            record.skuMaterialStatus = Status['审核失败']
            record.editorStatus = true
          } else {
            record[code].failReason = ''
            record[code].status = 3
          }
        })
        if (record['smartPicTransparent']) {
          record['smartPicTransparent'].failReason = ''
        }
        if (record['smartPicWhite']) {
          record['smartPicWhite'].failReason = ''
        }
      }
    })
    updateData({
      skuId: record.skuId,
      status: false,
    })
  } else {
    updateData({
      skuId: '',
      status: false,
    })
  }
}

const cellSubmit = ({ record, form, rowIndex, save, updateData, setSubmitLoading }) => {
  const arr = []
  Object.keys(form.getFieldsValue()).forEach((i) => {
    if (rowIndex === +i.split('-')[0]) {
      arr.push(i)
    }
  })
  form
    .validateFields(arr)
    .then((r) => {
      const postData = {
        skuId: record.skuId,
      }
      Object.keys(r).forEach((item) => {
        postData[item.split('-')[1]] = r[item]
      })

      const showConfirm = () => {
        let show = true
        const a = postData['smartContentSell']
        const b = postData['smartContentSell2']
        const c = postData['smartContentSell3']
        if ((a && b) || (b && c) || (a && c)) {
          show = false
        }
        Object.keys(postData)
          .filter((i) => !['smartContentSell', 'smartContentSell2', 'smartContentSell3'].includes(i))
          .forEach((item) => {
            if (!postData[item]) {
              show = true
            }
          })
        return show
      }
      const saveData = () => {
        save({
          postData,
          record,
          changeStatus: (res) => {
            setSubmitLoading(false)
            if (res) {
              resultCallback(res, record, postData, updateData)
            }
          },
        })
      }
      if (showConfirm()) {
        confirm({
          title: '当前有部分商品sku素材维护不完整，可能影响商品上场，请问是否确认保存？',
          icon: <ExclamationCircleOutlined />,
          onOk() {
            saveData()
          },
          onCancel() {
            setSubmitLoading(false)
          },
        })
      } else {
        saveData()
      }
    })
    .catch((e) => {
      setSubmitLoading(false)
    })
}

export const GetStatusBtn = (props) => {
  const { data } = props
  const { record, form, rowIndex, updateData, save, showErpFeedBack = () => {} } = data
  const showFeedBack = useContext(UserFeedbackComContext) || (() => {});
  const appType = useContext(AppTypeContext)
  const [submitLoading, setSubmitLoading] = useState(false);
  
  const saveTextElement = useMemo(
    () => (
      <span key="save" clstag={appType === 'shop' ? shopLogClstag['saveBtnClick'] : erpLogClstag['saveBtnClick']}>
        保存
      </span>
    ),
    []
  )

  const onClickHandler = () => {
    // 用户反馈组件强提醒
    showFeedBack(['CJ_LISTEN_YXSJD_GFYXHD', 'GFYXHD_HDXQY', 'GFYXHD_HDXQY_SCWH'])
    showErpFeedBack()
    setSubmitLoading(true)
    cellSubmit({ record, form, rowIndex, save, updateData, setSubmitLoading })
  }

  let statusButton: React.ReactElement = null
  const { skuMaterialStatus } = record
  switch (Status[skuMaterialStatus]) {
    case '未完善':
      statusButton = (
        <Button
          type="link"
          loading={submitLoading}
          onClick={onClickHandler}
        >
          {saveTextElement}
        </Button>
      )
      break
    // case '审核中':
    // case '机审通过':
    //   return <div style={{ paddingLeft: 28 }}>-</div>
    case '审核失败':
      statusButton = (
        <Button
          type="link"
          loading={submitLoading}
          onClick={onClickHandler}
        >
          {saveTextElement}
        </Button>
      )
      break
    case '审核成功':
    case '审核中':
    case '机审通过':
      statusButton = (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {record.editorStatus ? (
            <React.Fragment>
              <Button
                type="link"
                style={{ padding: '4px 0 4px 15px', marginRight: 10 }}
                loading={submitLoading}
                onClick={onClickHandler}
              >
                {saveTextElement}
              </Button>
              <Button type="link" style={{ padding: 0 }} onClick={() => resetStatus(record, updateData)}>
                取消
              </Button>
            </React.Fragment>
          ) : (
            <Button
              type="link"
              onClick={() => {
                record.editorStatus = true
                updateData({
                  skuId: record.skuId,
                  status: false,
                })
              }}
            >
              <span
                key="edit"
                clstag={appType === 'shop' ? shopLogClstag['editBtnClick'] : erpLogClstag['editBtnClick']}
              >
                修改
              </span>
            </Button>
          )}
        </div>
      )
      break
    default:
      statusButton = <div> </div>
  }
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {statusButton}
    </div>
  )
}
